/**
 * BadgeWithTooltip Component
 *
 * Wraps any badge with a tooltip for contextual information.
 * Follows the existing HelpTooltip pattern for consistency.
 */

import { Tooltip, Box, Text } from '@shopify/polaris';
import type { ReactNode } from 'react';

export interface BadgeWithTooltipProps {
  /** The badge element to wrap */
  badge: ReactNode;
  /** Tooltip message to display on hover */
  tooltipContent: string;
  /** Preferred tooltip position */
  preferredPosition?: 'above' | 'below' | 'mostSpace';
}

/**
 * Wraps a badge with a tooltip for hover information
 */
export function BadgeWithTooltip({
  badge,
  tooltipContent,
  preferredPosition = 'above',
}: BadgeWithTooltipProps) {
  const content = (
    <Box maxWidth="220px">
      <Text as="span" variant="bodySm">
        {tooltipContent}
      </Text>
    </Box>
  );

  return (
    <Tooltip content={content} preferredPosition={preferredPosition}>
      <span style={{ display: 'inline-flex', cursor: 'help' }}>{badge}</span>
    </Tooltip>
  );
}
